import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
  TextField,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Download as ExportIcon } from 'react-feather';
import { _reimbursementAxios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import CustomButton from 'src/components/common/customButton';
import { userLogout } from '../../../../utils/userLogout';

import constants from "../../../../config/constants.json"
import { ReimbursemntActionItems } from 'src/enums/reimbursmentEnums';

const workflowStatusCodes = constants.workflowStatusCodes;

const sleep = (time) => new Promise((acc) => setTimeout(acc, time));
const ReimbursementResult = (props) => {
  const [remark, setRemark] = useState();
  const [approvePopUp, setApprovePopUp] = useState(false);
  const [rejectPopUp, setRejectPopUp] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusChange, setStatusChange] = useState();
  const [claimid, setClaimid] = useState();
  const [claimRemarks, setClaimRemarks] = useState();
  const [activeTable, setActiveTable] = useState(0);
  const [checkNextItem, setCheckNextItem] = useState(false);
  // const [isCheckAll, setIsCheckAll] = useState(false);
  // const [isCheck, setIsCheck] = useState([]);
  // const [bulkClaims, setBulkClaims] = useState([]);

  useEffect(() => {
    setCheckNextItem(props.nextActionItems.length > 0 && props.nextActionItems.includes(ReimbursemntActionItems.ViewClaims))
  }, [props.nextActionItems]);

  const submitClaim = async (status, remarks) => {
    let search = false;
    if (props.searchedClaim.length > 0) search = true;

    let newStatusId;
    let claimStatus;
    if (status === 'rejected') {
      claimStatus = 'recheck';
      newStatusId = workflowStatusCodes.claim.recheck;
    } else {
      if (
        remarks === 'partially pre approved'
      ) {
        claimStatus = 'partially approved';
        newStatusId = workflowStatusCodes.claim['partially approved'];
      } else if (
        remarks === 'pre approved'
      ) {
        claimStatus = 'approved';
        newStatusId = workflowStatusCodes.claim.approved;
      } else if (
        remarks === 'pre rejected'
      ) {
        claimStatus = 'rejected';
        newStatusId = workflowStatusCodes.claim.rejected;
      }
    }

    let payLoad = {
      claimid: claimid,
      remarks: claimStatus,
      clientclaimremark: claimRemarks,
      newStatus: newStatusId
    };

    setIsSubmitting(true);
    _reimbursementAxios
      .post('reimbursement/claimStatusChange', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        console.log(response);
        if (response.data && response.data.isSuccess) {
          setIsSubmitting(false);
          if (status === 'approved') {
            setClaimRemarks();
            setApprovePopUp(false);
            props.onFilter(props.payload);
          } else {
            setClaimRemarks();
            setRejectPopUp(false);
            props.onFilter(props.payload);
          }

          if (search) {
            window.location.reload();
          }
        } else {
          setIsSubmitting(false);
          setStatusChange('Oops something went wrong please try again');
        }
      })
      .catch((error) => {
        //if 401, user session expired, logout the user
        setIsSubmitting(false);
        setStatusChange(error?.response?.data?.message);
        if(error?.response?.status === 401 || error?.response?.status === 403){
          userLogout();
        } 
      });
  };

  const submitBulkClaims = (status) => {
    let payLoad = {
      claims: props.bulkClaims,
      clientclaimremark: claimRemarks
    };
    setIsSubmitting(true);
    _reimbursementAxios
      .post('reimbursement/bulkUpload', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        console.log(response);
        if (response.data && response.data.isSuccess) {
          setIsSubmitting(false);
          if (status === 'approve') {
            setApprovePopUp(false);
            props.onFilter(props.payload);
          } else {
            setRejectPopUp(false);
            props.onFilter(props.payload);
          }
        } else {
          setIsSubmitting(false);
          setStatusChange('Oops something went wrong please try again');
        }
      })
      .catch((error) => {
        //if 401, user session expired, logout the user
        if(error?.response?.status === 401 || error?.response?.status === 403){
          userLogout();
        } 

        console.log(error);
      });
  };

  const handleLimitChange = (event) => {
    let limit = event.target.value;
    props.limitHandler(event.target.value);
    if (props.isSelectAll) {
      let arr1 = [];
      let arr2 = [];
      for (var i = (props.page * limit); i < ((props.page + 1) * limit); ++i) {
        if (i >= props.level1Claims.length)
          break;
        let tempArr = [];
        tempArr.push(props.level1Claims[i].claimid);
        tempArr.push(props.level1Claims[i].remarks);
        arr1.push(props.level1Claims[i].claimid);
        arr2.push(tempArr);
      }
      // setIsCheck(arr1);
      props.isSelectHandler(arr1);
      props.isBulkSelectHandler(arr2);
    }
    // setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    props.pageHandler(newPage);
    // setPage(newPage);
  };

  const handleClick = (e, claimid, status) => {
    let arr = [];
    arr.push(claimid);
    arr.push(status);
    const { checked } = e.target;
    props.isBulkSelectHandler([...props.bulkClaims, arr]);
    props.isSelectHandler([...props.isCheck, claimid]);
    if (!checked) {
      props.isSelectHandler(props.isCheck.filter((item) => item !== claimid));
      props.isBulkSelectHandler(props.bulkClaims.filter((item) => item[0] !== claimid));
    }
  };

  const handleSelectAll = (e) => {
    props.selectAllHandler(!(props.isSelectAll))
    let arr1 = [];
    let arr2 = [];
    for (var i = (props.page * props.limit); i < ((props.page + 1) * props.limit); ++i) {
      if (i >= props.level1Claims.length)
        break;
      let tempArr = [];
      tempArr.push(props.level1Claims[i].claimid);
      tempArr.push(props.level1Claims[i].remarks);
      arr1.push(props.level1Claims[i].claimid);
      arr2.push(tempArr);
    }
    props.isSelectHandler(arr1);
    props.isBulkSelectHandler(arr2);
    if (props.isSelectAll) {
      props.isSelectHandler([]);
      props.isBulkSelectHandler([]);
    }
  };

  const approveOpen = (claimId, remark, flag) => {
    setApprovePopUp(true);
    if (flag) {
      setIsBulk(flag);
    } else {
      setClaimid(claimId);
      setRemark(remark);
    }
  };

  const approveClose = () => {
    setRemark();
    setClaimRemarks();
    setApprovePopUp(false);
    setIsBulk(false);
    setStatusChange();
  };

  const rejectOpen = (claimId, remark, flag) => {
    setRejectPopUp(true);
    if (flag) {
      setIsBulk(flag);
    } else {
      setClaimid(claimId);
      setRemark(remark);
    }
  };

  const rejectClose = () => {
    setRemark();
    setClaimRemarks();
    setRejectPopUp(false);
    setIsBulk(false);
    setStatusChange();
  };

  const switchTab = async (num) => {
    setActiveTable(num);
    props.changeTab(num);
  };

  return (
    <>
      <Grid xs={12} justifyContent="space-between" container item>
        <Grid
          item
          container
          sx={{
            borderRadius: 3,
            border: '1px solid #1778f2',
            width: '452px',
            height: '40px'
          }}
        >
          <CustomButton
            onClick={() => switchTab(0)}
            fontSize={12}
            shadow="false"
            active={activeTable == 0}
            title="Level one Claims"
            sx={{
              borderRadius: 2,
              height: '100%',
              width: '150px'
            }}
          />
          <CustomButton
            onClick={() => switchTab(1)}
            fontSize={12}
            shadow="false"
            active={activeTable == 1}
            title="Actioned Claims"
            sx={{
              borderRadius: 2,
              height: '100%',
              width: '150px'
            }}
          />
          <CustomButton
            onClick={() => switchTab(2)}
            fontSize={12}
            shadow="false"
            active={activeTable == 2}
            title="Claim Under Query"
            sx={{
              borderRadius: 2,
              height: '100%',
              width: '150px'
            }}
          />
        </Grid>
        {props.isCheck.length > 0 &&
          activeTable === 0 &&
          props.searchedClaim.length === 0 ? (
          <Grid
            item
            container
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '160px',
              margin: '5px',
              borderRadius: 3,
              border: '1px solid #1778f2',
              height: '40px'
            }}
          > 
            <Button disabled={checkNextItem ? true : false} onClick={() => approveOpen(0, 0, true)}>Approve</Button>            
            {/* <Button onClick={() => rejectOpen(0, 0, true)}>Reject</Button> */}
          </Grid>
        ) : (
          <></>
        )}
        {props.isCheck.length == 0 ? (
          <Grid
            item
            container
            sx={{
              width: '180px',
              '@media (max-width: 727px)': {
                mt: 1.5
              }
            }}
          >
            <ButtonGroup
              variant="text"
              disabled={false}
              sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15 }}
            >
              <Button
                sx={{ px: 2 }}
                onClick={() => {
                  props.downloadResults();
                }}
                startIcon={<ExportIcon size="18" />}
              >
                Export
              </Button>
            </ButtonGroup>
          </Grid>
        ) : null}
      </Grid>
      <Grid xs item>
        <Card elevation={0} sx={{ mt: 2 }}>
          <PerfectScrollbar>
            <Box>
              {
                !props.message ?
                  <TableContainer sx={{ width: '100%', display: 'block' }}>
                    <Table
                      stickyHeader
                      aria-label="claim list"
                      id="claim-list"
                      sx={{ width: '100%', tableLayout: 'fixed' }
                      }
                    >
                      <TableHead>
                        <TableRow>
                          {props.searchedClaim.length > 0 || activeTable === 1 ? (
                            <></>
                          ) : (
                            <TableCell padding="checkbox">
                              <Checkbox
                                sx={{
                                  '& .MuiSvgIcon-root': {
                                    fontSize: 18
                                  }
                                }}
                                color="primary"
                                onChange={(e) => handleSelectAll(e)}
                                checked={props.isSelectAll}
                                disabled={checkNextItem ? true : false}
                              />
                            </TableCell>
                          )}
                          <TableCell>Claim Id</TableCell>
                          <TableCell>CorporateName</TableCell>
                          <TableCell>PatientName</TableCell>
                          <TableCell>EmployeeId</TableCell>
                          <TableCell>ClaimAmount</TableCell>
                          <TableCell>Approvedamount</TableCell>
                          <TableCell>Status</TableCell>
                          {/* <TableCell>Insurer Status</TableCell> */}
                          <TableCell>Action</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      {props.level1Claims.length > 0 ||
                        props.searchedClaim.length > 0 ||
                        props.actedClaims.length > 0 ? (
                        <TableBody>
                          {(props.searchedClaim.length > 0
                            ? props.searchedClaim.length > 0
                              ? props.searchedClaim.slice(
                                props.page * props.limit,
                                (props.page + 1) * props.limit
                              )
                              : props.searchedClaim
                            : activeTable === 0
                              ? props.level1Claims.length > 0
                                ? props.level1Claims.slice(
                                  props.page * props.limit,
                                  (props.page + 1) * props.limit
                                )
                                : props.level1Claims
                              : props.actedClaims.length > 0
                                ? props.actedClaims.slice(
                                  props.page * props.limit,
                                  (props.page + 1) * props.limit
                                )
                                : props.actedClaims
                          ).map((claim, idx) => (
                            <TableRow hover key={idx}>
                              {props.searchedClaim.length > 0 ||
                                activeTable === 1 ? (
                                <></>
                              ) : (
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: 18
                                      }
                                    }}
                                    color="primary"
                                    onChange={(e) =>
                                      handleClick(e, claim.claimid, claim.remarks)
                                    }
                                    checked={props.isCheck.includes(claim.claimid)}
                                    disabled={checkNextItem ? true : false}
                                  />
                                </TableCell>
                              )}
                              <TableCell>{claim.claimid}</TableCell>
                              <TableCell>{props.entityListData[claim.entityid]}</TableCell>
                              <TableCell>{claim.name} </TableCell>
                              <TableCell>{claim.employeeid}</TableCell>
                              <TableCell>{claim.claimamount}</TableCell>
                              <TableCell>{claim.approvedclaimamount}</TableCell>
                              <TableCell>{claim.remarks}</TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  style={{
                                    width: '100%',
                                    textAlgin: 'center',
                                    fontSize: '12px'
                                  }}
                                  onClick={() =>
                                    approveOpen(claim.claimid, claim.remarks, false)
                                  }
                                  disabled={
                                    [
                                      'approved',
                                      'rejected',
                                      'partially approved',
                                      'recheck',
                                      'raised for payment',
                                      "information required",
                                      "submitted",
                                      "resubmitted"
                                    ].includes(claim.remarks) || (checkNextItem)
                                    // claim.remarks === 'approved' ||
                                    //   claim.remarks === 'rejected' ||
                                    //   claim.remarks === 'partially approved' ||
                                    //   claim.remarks === 'recheck' ||
                                    //   claim.remarks === 'raised for payment'
                                      //"information required","submitted"
                                      ? true
                                      : false
                                  }
                                >
                                  Approve
                                </Button>
                                <Button
                                  variant="contained"
                                  style={{
                                    width: '100%',
                                    textAlgin: 'center',
                                    marginTop: '5px',
                                    fontSize: '12px'
                                  }}
                                  onClick={() =>
                                    rejectOpen(claim.claimid, claim.remarks, false)
                                  }
                                  disabled={
                                    [
                                      'approved',
                                      'rejected',
                                      'partially approved',
                                      'recheck',
                                      "information required",
                                      "submitted",
                                      "resubmitted"
                                    ].includes( claim.remarks)
                                      ? true
                                      : false || (checkNextItem)
                                      
                                  }
                                >
                                  Reject
                                </Button>
                              </TableCell>
                              <TableCell>
                                <Link
                                  to={`claimDetails/${claim.employeeid}/${claim.claimid}`}
                                  target="_blank"
                                >
                                  <Button>View</Button>
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      ) : null}
                    </Table>
                  </TableContainer> :
                  <>
                    <p style={{ color: '#212529', textAlign: 'center' }}>
                      <strong>{props.message}</strong>
                    </p>
                  </>
              }
            </Box>
            <Dialog open={approvePopUp} onClose={approveClose}>
              <DialogContent>
                <DialogContentText>
                  {isBulk
                    ? 'Are you sure want to approve (' +
                    props.bulkClaims.length +
                    ') ' +
                    'claims'
                    : 'Are you sure want to approve this claim'}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="remarks"
                  label="Claim Remarks"
                  type="text"
                  fullWidth
                  variant="standard"
                  onChange={(event) => setClaimRemarks(event.target.value)}
                />
              </DialogContent>
              <DialogActions>
                {statusChange ? (
                  <p style={{ marginTop: '10px', color: '#FC1721' }}>
                    {' '}
                    {statusChange} &nbsp;
                  </p>
                ) : (
                  <></>
                )}
                <Button onClick={approveClose}>Cancel</Button>
                <Button
                  startIcon={
                    isSubmitting ? <CircularProgress size="1rem" /> : null
                  }
                  onClick={() =>
                    isBulk
                      ? submitBulkClaims('approve')
                      : submitClaim('approved', remark)
                  }
                >
                  {isSubmitting ? 'Processing' : 'Approve'}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={rejectPopUp} onClose={rejectClose}>
              <DialogContent>
                <DialogContentText>
                  {isBulk
                    ? 'Are you sure want to reject (' +
                    props.bulkClaims.length +
                    ')' +
                    'claims'
                    : 'Are you sure want to reject this claim'}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="remarks"
                  label="Claim Remarks *"
                  type="text"
                  fullWidth
                  variant="standard"
                  onChange={(event) => setClaimRemarks(event.target.value)}
                />
              </DialogContent>
              <DialogActions>
                {statusChange ? (
                  <p style={{ marginTop: '10px', color: '#FC1721' }}>
                    {' '}
                    {statusChange} &nbsp;
                  </p>
                ) : (
                  <></>
                )}
                <Button onClick={rejectClose}>Cancel</Button>
                <Button
                  disabled={claimRemarks ? false : true}
                  startIcon={
                    isSubmitting ? <CircularProgress size="1rem" /> : null
                  }
                  onClick={() =>
                    isBulk
                      ? submitBulkClaims('reject')
                      : submitClaim('rejected', remark)
                  }
                >
                  {isSubmitting ? 'Processing' : 'Reject'}
                </Button>
              </DialogActions>
            </Dialog>
          </PerfectScrollbar>
          {
            !props.message ?
              <TablePagination
                component="div"
                count={
                  props.searchedClaim.length > 0
                    ? props.searchedClaim.length
                    : activeTable === 0
                      ? props.level1Claims.length
                      : props.actedClaims.length
                }
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={props.page}
                rowsPerPage={props.limit}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
              /> : <></>
          }
        </Card>
      </Grid>
    </>
  );
};

export default ReimbursementResult;
